import { httpResource } from '@angular/common/http';
import { Injectable } from '@angular/core';
import type { IPerson } from '@modules/contacts/shared';

export interface MePersonResponse {
  person: IPerson | null;
}

@Injectable({ providedIn: 'root' })
export class OrganizationMePersonApiService {
  readonly #base = '/api/v1/organization/me/person';

  mePersonResource(organizationId: () => string | undefined) {
    return httpResource(
      () => {
        const value = organizationId();
        return value
          ? {
              url: this.#base,
              method: 'GET' as const,
              params: { organizationId: value },
              withCredentials: true,
            }
          : undefined;
      },
      {
        parse: (raw: unknown): IPerson | null =>
          (raw as MePersonResponse).person ?? null,
      },
    );
  }
}
